(function () {
  var STORAGE_KEY = 'newsletter-popup-dismissed-until';

  document.querySelectorAll('[data-newsletter-popup]').forEach(function (overlay) {
    if (overlay.hasAttribute('data-disabled')) return;

    var dismissedUntil = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
    if (Date.now() < dismissedUntil) return;

    var delay = parseInt(overlay.getAttribute('data-delay') || '4000', 10);
    var frequencyDays = parseInt(overlay.getAttribute('data-frequency') || '7', 10);
    var closeBtn = overlay.querySelector('[data-newsletter-popup-close]');
    var form = overlay.querySelector('form');
    var formState = overlay.querySelector('[data-newsletter-popup-state="form"]');
    var successState = overlay.querySelector('[data-newsletter-popup-state="success"]');

    function dismiss(days) {
      var until = Date.now() + days * 24 * 60 * 60 * 1000;
      localStorage.setItem(STORAGE_KEY, String(until));
      overlay.classList.remove('is-visible');
    }

    function show() {
      overlay.classList.add('is-visible');
      var input = overlay.querySelector('input[type="email"]');
      if (input) input.focus();
    }

    var timer = setTimeout(show, delay);

    closeBtn.addEventListener('click', function () {
      clearTimeout(timer);
      dismiss(frequencyDays);
    });

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) {
        dismiss(frequencyDays);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && overlay.classList.contains('is-visible')) {
        dismiss(frequencyDays);
      }
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;

        fetch(form.getAttribute('action') || '/contact', {
          method: 'POST',
          body: new FormData(form)
        })
          .then(function () {
            formState.hidden = true;
            successState.hidden = false;
            dismiss(365);
            setTimeout(function () {
              overlay.classList.remove('is-visible');
            }, 3500);
          })
          .catch(function () {
            if (submitBtn) submitBtn.disabled = false;
          });
      });
    }
  });
})();